import React from 'react'
import { PostEvent } from '../PostEvent/PostEvent'
import { Divider } from '../../common/Divider'
import { PostEventCard } from '../../../generated/api/post-row'

interface PostEventsProps {
  events: PostEventCard[]
  disabled?: boolean
}

export const PostEvents = ({
  events,
  disabled,
}: PostEventsProps): React.ReactNode => {
  if (events.length === 0) {
    return null
  }

  return (
    <>
      <Divider />
      <div className="flex flex-col gap-4">
        {events.map((event) => (
          <PostEvent key={event.id} event={event} disabled={disabled} />
        ))}
      </div>
    </>
  )
}
